<div class="footer-container flex-col space-between">
    <div class="footer-top-content mx-3">
        <div class="w-30"><img [src]="logoSource" height="60"></div>
        <div class="flex-row items-center hide-lt-md">
            <a routerLink='/privacy-policy' color="primary" ><span class="uppercase ws-nowrap">Privacy</span></a>
            |
            <a routerLink='/terms-of-use' color="primary" ><span class="uppercase ws-nowrap">Terms Of Use</span></a>
            |
            <a routerLink='/accessibility' color="primary"><span class="uppercase ws-nowrap">Accessibility</span></a>
            |
            <a routerLink='/licensing' color="primary"><span class="uppercase ws-nowrap">Licensing</span></a>
        </div>
        <div class="w-30 flex-row justify-end"><img [src]="eggSource" height="40"></div>
    </div>
    <div class="flex-row items-center justify-center hide-gt-sm">
        <a routerLink='/privacy-policy' color="primary" ><span class="uppercase ws-nowrap">Privacy</span></a>
        |
        <a routerLink='/terms-of-use' color="primary" ><span class="uppercase ws-nowrap">Terms Of Use</span></a>
        |
        <a routerLink='/accessibility' color="primary"><span class="uppercase ws-nowrap">Accessibility</span></a>
        |
        <a routerLink='/licensing' color="primary"><span class="uppercase ws-nowrap">Licensing</span></a>
    </div>
    <div class="footer-bottom-content copyright mx-3">
        <span class="flex-row items-center">Copyright © 2026 All Rights Reserved</span>
        <span class="flex-row items-center hide-lt-md">v{{currentApplicationVersion}}</span>
        <span class="flex-row items-center"><span class="hide-lt-md">Designed & Developed by </span><h3 class="ml-2">Super Sites LLC</h3></span>
    </div>
</div>                 